/**
 * Document view component.
 * @module components/theme/View/ListingView
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Card, Container as SemanticContainer } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions';
import { UniversalLink, Pagination } from '@plone/volto/components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faArrowRight } from '@fortawesome/free-solid-svg-icons';

/**
 * List view component class.
 * @function ListingView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const ListingView = ({ content }) => {
  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  const PreviewImage = config.getComponent({ name: 'PreviewImage' }).component;

  const dispatch = useDispatch();
  const items = useSelector((state) => state.search.subrequests.items?.items);
  const total = useSelector((state) => state.search.subrequests.items?.total);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(30);

  useEffect(() => {
    let contentFilter = {
      b_size: pageSize,
      b_start: currentPage * pageSize,
      sort_on: 'getObjPositionInParent',
      metadata_fields: ['content_icon', 'getRemoteUrl'],
    };
    contentFilter['path.depth'] = 1
    dispatch(searchContent(flattenToAppURL(content['@id']), contentFilter, 'items'));
  }, [dispatch, currentPage, pageSize]);

  const onChangePage = (event, activePage) => {
    event.preventDefault();
    setCurrentPage(activePage.value);
  };

  const onChangePageSize = (event) => {
    event.preventDefault();
    setPageSize(parseInt(event.target.text));
    setCurrentPage(0);
  };

  const getViewURL = function (item) {
    let URL = flattenToAppURL(item['@id'])
    if (item['@type'] === 'File') {
      URL += '/@@display-file/file'
    }
    if (item['@type'] === 'Image') {
      URL += '/@@display-file/image'
    }
    if (item?.getRemoteUrl) {
      URL = item?.getRemoteUrl
    }
    return URL
  }

  return (

    <div >
      <ul className='list-unstyled listingDefault my-0'>
        {items &&
          items.map((item, index) => (
            <li key={item['@id']} as="li" className='mb-4' >
              <span>{item.url}</span>
              <Card fluid className="listing-item pos-relative" as="article">
                <Card.Content className='w-100'>
                  <Card.Header as="h2" className='listing-item__title mb-0' >
                    <UniversalLink href={getViewURL(item)} className="stretched-link">
                      {item.title}
                    </UniversalLink>
                  </Card.Header>
                  {item.description &&
                    <Card.Description as="p">{item.description}</Card.Description>
                  }
                  <span className="item__readMore d-block text-end pt-2">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </Card.Content>
              </Card>

            </li>
          ))}
      </ul>

      {total > pageSize && (
        <nav className="pagination">
          <Pagination
            current={currentPage}
            total={Math.ceil(total / pageSize)}
            onChangePage={onChangePage}
            onChangePageSize={onChangePageSize}
          />
        </nav>
      )}

    </div>

  );
};


export default ListingView;
